// Written in this round about way for babel-transform-imports
import Router from "react-router/es/Router";

export default Router;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-router-dom/es/Router.js
// module id = 339
// module chunks = 4 5 6 7